import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { UserToken } from "../../../../../auth/user-token.model";
import { LoaderService } from "../../../../../core/interceptor/loader/loader.service";
import { MessagingService } from "../../../../../core/messaging/messaging.service";
import { SeverityType } from "../../../../../core/messaging/severity-type.enum";
import { UserService } from "../../../../../core/user/user.service";
import { FormService } from "../../../../../dynamic-forms/form.service";
import { Dropdown } from "../../../../../dynamic-forms/inputs/dropdown/dropdown.model";
import { SelectableInput } from "../../../../../dynamic-forms/inputs/selectable-input.model";
import { TextboxType } from "../../../../../dynamic-forms/inputs/textbox/textbox-type.enum";
import { Textbox } from "../../../../../dynamic-forms/inputs/textbox/textbox.model";
import { DocumentPageAssignmentComponent } from "../../../../../shared/document-page-assignment/document-page-assignment.component";
import { DocumentPageViewerComponent } from "../../../../../shared/document/document-page-viewer/document-page-viewer.component";
import { ListItem } from "../../../../../shared/list/list-item";
import { MemberCentricChase } from "../../../../../shared/membercentric-doc-attachment/membercentric-chase.model";
import { MemberCentricDocAttachmentService } from "../../../../../shared/membercentric-doc-attachment/membercentric-doc-attachment.service";
import { MenuItem } from "../../../../../shared/menu/menu-item.model";
import { EmitState } from "../../../../../shared/models/emit-state.model";
import { ConfirmationModalComponent } from "../../../../../shared/panel/confirmation-modal/confirmation-modal.component";
import { ModalComponent } from "../../../../../shared/panel/modal/modal.component";
import { ChasePendItem } from "../../../../../shared/pend/chase-pend-item.model";
import { CreatePendService } from "../../../../../shared/pend/create-pend.service";
import { DocumentPageRequest } from "../../../../../shared/pend/document-pageid-request.model";
import { PendStatus } from "../../../../../shared/pend/pend-status.enum";
import { PendType } from "../../../../../shared/pend/pend-type.enum";
import { ArrayHelper } from "../../../../../utilities/contracts/array-helper";
import { NumberHelper } from "../../../../../utilities/contracts/number-helper";
import { StringHelper } from "../../../../../utilities/contracts/string-helper";
import { RegExHelper } from "../../../../../utilities/reg-Ex-Helper";
import { MemberItem } from "../../../../api/member-v2/member-item.model";
import { MemberValidation } from "../../../../api/member-validation/member-validation.model";
import { MemberValidationService } from "../../../../api/member-validation/member-validation.service";
import { InvoicesService } from "../../../invoice/invoices/invoices.service";
import { REVIEW_ALL_PAGES_OF_CHART } from "../../../member/chase-detail/chase-detail-chart/attributes";
import { Encounter } from "../../../member/chase-detail/chase-detail-chart/risk/encounter/encounter.model";
import { ChaseDetailService } from "../../../member/chase-detail/chase-detail.service";
import { DocumentSourceType } from "../../../retrieval/retrieval-document-source-type.enum";
import { ServiceOrgAttribute } from "../../../service-org-admin/service-org-config/model/service-org-attribute.model";
import { ServiceOrgConfigurationService } from "../../../service-org-admin/service-org-config/service-org-config.service";
import { RetrievalDocumentServiceService } from "../../retrieval-document-service.service";
import { ChasePageHistory } from "../chase-page-history.model";
import { DocumentReviewLevel } from "../document-review-level.enum";
import { DocumentTypeName } from "../document-type.enum";
import { PageTypeName } from "../page-type.enum";
import { DocumentAssignmentSummary } from "./document-assignment-summary.model";
import { DocumentIntakePage } from "./document-intake-page";
import { DocumentSummary } from "./document-summary.model";
import { MemberAssignmentRequest } from "./member-assignment-request.model";
import { MemberAssignmentSummary } from "./member-assignment-summary.model";
import { MemberData } from "./member.data.model";

enum PageSource {
  DOC_QA = "DOCQA",
}

@Component({
  selector: "app-retreival-document-intake",
  templateUrl: "./retreival-document-intake.component.html",
  styleUrls: ["./retreival-document-intake.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RetreivalDocumentIntakeComponent implements OnInit, OnChanges {
  @Input() documentId: number;
  @Input() sourceDocumentTypeId: number;
  @Output() pageEvent = new EventEmitter<number>();
  @Output() changedEvent = new EventEmitter();
  @Output() notifyDocumentStatusChanged = new EventEmitter<any>();
  @Output() assignedPagesEvent = new EventEmitter<number>();
  @Output() unassignedPagesEvent = new EventEmitter<number[]>();
  @Output() createDosPursuit = new EventEmitter<string>();
  @Input() currentlyAssignedUser: number;
  @Input() isChartLakeIntake: boolean;
  numberOfAssignedPages: number;
  reviewAllPagesAttribute: boolean;
  selectedMember: MemberItem | null = null;
  showErrorModal = false;
  errorMessage: string;
  constructor(private service: RetrievalDocumentServiceService,
              private changeDetector: ChangeDetectorRef,
              private readonly loaderService: LoaderService,
              private router: Router,
              private messagingService: MessagingService,
              private readonly chaseDetailService: ChaseDetailService,
              private readonly memberValidationService: MemberValidationService,
              private userService: UserService,
              private memberCentricDocAttachmentService: MemberCentricDocAttachmentService,
              private pendService: CreatePendService,
              private readonly formService: FormService,
              private serviceOrgConfigurationService: ServiceOrgConfigurationService,
              private readonly invoicesService: InvoicesService
  ) {
  }
  @ViewChild("confirmationForInActiveChases", { static: true }) confirmationForInActiveChases: ConfirmationModalComponent;
  @ViewChild("confirmationForActiveChases", { static: true }) confirmationForActiveChases: ConfirmationModalComponent;
  @ViewChild("documentPageAssignment", { static: true }) documentPageAssignment: DocumentPageAssignmentComponent;
  @ViewChild("notAllowedModal", { static: true }) notAllowedModal: ModalComponent;

  @ViewChild(DocumentPageViewerComponent, { static: true })
  private pageViewerComponent: DocumentPageViewerComponent;
  loggedInUser: UserToken;
  documentSummary: DocumentSummary;
  documentIntakePages: DocumentIntakePage[] = [];
  documentAssignmentSummaries: DocumentAssignmentSummary[] = [];
  currentdocumentIntakePage: DocumentIntakePage;
  pageHistories: ChasePageHistory[] = [];
  currentPageNumber: number;
  maxPages = 3;
  pageloading = 0;
  numberOfPages = 0;
  docTypeInvoice = 4;
  docTypePrePayInvoice = 5;
  showDialog = false;
  currentAssignSection: string;
  invoiceType = 0;
  runMode: number;
  runModeDocument = 1;
  runModeChase = 2;
  previousDocumentId = 0;
  showConfirmationForInActiveChases: boolean;
  showConfirmationForActiveChases: boolean;
  confirmationTextForAttachingToActiveChase: string;
  confirmationTextForAttachingToInactiveChase: string;
  chaseActive: boolean;
  showMemberCentricDocAttachmentInfo = false;
  memberCentricData: MemberCentricChase[];
  lastSelectedSection: string;

  chaseForm: FormGroup;
  ignoreForm: FormGroup;
  invoiceForm: FormGroup;
  deleteForm: FormGroup;
  chaseSearchTarget: FormControl;
  pendForm: FormGroup;

  defaultFormValidators: any[] = [];

  memberValidationData = new MemberValidation();
  private chaseDetails: ListItem[] = [];
  idSubscriber: Subscription;
  savedIsValidMember: boolean;
  currentlyAssignedTo: number;
  isChartMaxed = false;
  searchDocumentSourceTypeId?: number;
  disableDeleteBtn = false;
  ignoreBegPage: Textbox;
  ignoreEndPage: Textbox;
  chaseBegPage: Textbox;
  chaseEndPage: Textbox;
  assignChaseId: Textbox; // it will hold memberId if it is chart lake intake
  invoiceBegPage: Textbox;
  invoiceEndPage: Textbox;
  invoiceChaseId: Textbox;
  pendAmount: Textbox;
  pendInvoice: Textbox;
  pendBegPage: Textbox;
  pendEndPage: Textbox;
  pendTypes: Dropdown;
  pendCompany: Dropdown;
  pendReasonInput: Dropdown;
  deleteBegPage: Textbox;
  deleteEndPage: Textbox;
  assignPendChaseId: Textbox;
  unAssignEntityAlertVisible = false;
  docAssignmentData: DocumentAssignmentSummary;
  workingDocumentAssignmentSummaries: DocumentAssignmentSummary[] = [];
  attachChaseNotAllowedMsg: string[] = [];
  showNotAllowedModal: boolean;
  menuItems: MenuItem[] = [];
  selectedTab: MenuItem;
  showMemberInputs = true;
  encounterValidation: Encounter[] = [];
  encounterValidationFlag = true;

  ngOnInit() {
    this.loggedInUser = this.userService.getUserToken();
    this.previousDocumentId = this.documentId;

    this.defaultFormValidators = [
      Validators.required,
      Validators.min(1),
      Validators.pattern(RegExHelper.number),
    ];

    this.initializeDoc();
    this.setTabMenuItems();

    this.serviceOrgConfigurationService
      .getServiceOrgConfigurationByAttribute(REVIEW_ALL_PAGES_OF_CHART.attributeId)
      .pipe(map((attribute: ServiceOrgAttribute) => this.reviewAllPagesAttribute = attribute?.attributeValue === "1"))
      .subscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (NumberHelper.isAvailable(this.currentlyAssignedUser)) {
      this.initializeDoc();
      this.currentlyAssignedUser = null;
    } else if (NumberHelper.isGreaterThan(Number(this.previousDocumentId), 0) && this.previousDocumentId !== changes.documentId.currentValue) {
      this.initializeDoc();
      this.previousDocumentId = this.documentId;
    }
  }

  private setTabMenuItems(): void {
    this.service
      .getMenuItems()
      .subscribe(menuItems => {
        if (this.isRunModeDocument) {
          menuItems.find(m => m.description.toLowerCase() === "review").show = false;
          this.selectedTab = menuItems.find(m => m.description.toLowerCase() === "identification");
        } else if (this.isRunModeChase) {
          this.selectedTab = menuItems.find(m => m.description.toLowerCase() === "review");
        }

        this.menuItems = menuItems;
        this.changeDetector.markForCheck();
      });
  }

  hideTab(tabName: string): boolean {
    // Hide Tab
    if (this.selectedTab == undefined) {
      return null;
    }

    return this.selectedTab.description.toLowerCase() !== tabName.toLowerCase();
  }

  onSelectTab($event: MenuItem): void {
    this.selectedTab = $event;
  }

  getMemberValidation(): void {

    this.memberValidationService.getData(this.documentId, this.status).subscribe(data => {
      this.memberValidationData = data;
      this.savedIsValidMember = this.memberValidationData.isValid;
    });

  }
  getCurrentlyAssignedTo(): void {

    // Get currentlyAssignedTo to determine if editable by current user
    const assignedTo = this.chaseDetails.filter(x => x.key === "Assigned To Id");
    if (assignedTo !== null) {
      this.currentlyAssignedTo = parseInt(assignedTo[0].value || "0", 10);
    }
  }

  getData(): void {
    // Create observer object
    const observer = {
      next: this.assignAndNotify,
      error: null,
      complete: () => {
        if (this.isRunModeChase) {

          this.chaseDetailService.getSummaryItems(this.documentId)
            .subscribe(chaseDetails => {

              this.chaseDetails = chaseDetails;
              this.getCurrentlyAssignedTo();
              this.getMemberValidation();
              this.changeDetector.markForCheck();

            });
        }
      },
    };

    this.service
      .getDocumentSummary(this.documentId, this.sourceDocumentTypeId)
      .subscribe(observer);
  }


  get showMemberValidation(): boolean {

    if (this.currentlyAssignedTo === this.loggedInUser.userId && this.isRunModeChase) {
      return true;
    } else {
      return false;
    }

  }

  get allowEdit(): boolean {

    if (this.isRunModeChase && this.currentlyAssignedTo !== this.loggedInUser.userId) {
      return false;
    }

    if (this.isRunModeChase) {
      return this.savedIsValidMember;

    } else {

      return true;
    }
  }

  get status(): string {
    const statusItem = this.chaseDetails.find(item => item.key === "Workflow Status");
    return statusItem ? statusItem.value : "";
  }

  get isPursuitChase(): boolean {
    const parentChaseId = this.chaseDetails.find(item => item.key === "Parent Chase Id").value;
    return StringHelper.isAvailable(parentChaseId);
  }

  get showDosValidationSection(): boolean {
    const reviewLevel = this.chaseDetails.find(item => item.key === "Project DocumentReview Level");
    return reviewLevel ?
      (this.isRunModeChase && Number(reviewLevel.value) === DocumentReviewLevel.MemberAndDosValidationRisk
        || this.isRunModeChase && Number(reviewLevel.value) === DocumentReviewLevel.MemberAndDosValidationIva) : false;
  }

  setRunMode() {
    this.runMode = this.sourceDocumentTypeId;
  }

  searchChase(target) {
    this.searchDocumentSourceTypeId = null;

    this.showDialog = true;
    this.chaseSearchTarget = target;
  }

  searchChaseThirdParty(target) {
    this.searchDocumentSourceTypeId = null;
    this.showDialog = true;
    this.chaseSearchTarget = target;
  }

  searchClosed(chaseId) {
    if (this.chaseSelectedLimitCheck(chaseId)) {
      this.showDialog = false;
      if (chaseId) {
        this.chaseSearchTarget.setValue(chaseId);
      }
    }
  }

  memberSearchClosed(member): void {
      this.showDialog = false;
      if (member) {
        this.selectedMember = member;
        this.chaseSearchTarget.setValue(member?.memberId);
      }
  }

  clearMemberField(): void {
    this.chaseForm.reset();
    if (this.selectedMember) {
      this.selectedMember =  null;
    }
  }

  private chaseSelectedLimitCheck(chaseId): boolean {
    const chaseIds = chaseId
    .split(",")
    .map(id => Number(id.trim()))
    .filter(id => !isNaN(id)); // Removes any non-number entries

    if (chaseIds.length > 10) {
      this.messagingService.showToast("You can select a maximum of 10 chases. Please reduce your selection to proceed.", SeverityType.WARN);
      return false;
    } else {
      return true;
    }
  }

  private initializeDoc(): void {
    this.setRunMode();
    this.getData();
  }

  private assignAndNotify = (data: DocumentSummary): void => {

    this.documentSummary = data;
    this.numberOfPages = data.numberOfPages;
    if (StringHelper.isAvailable(this.lastSelectedSection)) { this.toggleAssignSection(this.lastSelectedSection); }
    this.pageEvent.emit(this.numberOfPages);
    DocumentPageViewerComponent.documentId.next(this.documentId);
    this.notifyDocumentStatusChanged.emit({
      documentStateDescription: data.description,
      documentStateGroupId: data.documentStateGroupId,
      documentStateId: data.documentStateId,
    });

    this.resetFormValidators(this.documentSummary);
    this.loadDocumentSections();
    this.assignedPageCount();
  }

  private resetFormValidators(documentSummary: DocumentSummary): void {
    let formValidators = [];
    formValidators = [...this.defaultFormValidators];
    formValidators.push(Validators.max(documentSummary.numberOfPages));
    const maxErrorMessage = `Enter number between 1 - ${documentSummary.numberOfPages}`;

    if (this.chaseForm) {
      this.chaseForm.get("chaseBegPage").setValidators(formValidators);
      this.chaseForm.get("chaseEndPage").setValidators(formValidators);
      this.chaseBegPage.errorMessages = {
        ...this.chaseBegPage?.errorMessages,
        max: maxErrorMessage,
      };
      this.chaseEndPage.errorMessages = {
        ...this.chaseEndPage?.errorMessages,
        max: maxErrorMessage,
      };
    }

    if (this.pendForm) {
      this.pendForm.get("pendBegPage").setValidators(formValidators);
      this.pendForm.get("pendEndPage").setValidators(formValidators);
      this.pendBegPage.errorMessages = {
        ...this.pendBegPage?.errorMessages,
        max: maxErrorMessage,
      };
      this.pendEndPage.errorMessages = {
        ...this.pendEndPage?.errorMessages,
        max: maxErrorMessage,
      };
    }

    if (this.ignoreForm) {
      this.ignoreForm.get("ignoreBegPage").setValidators(formValidators);
      this.ignoreForm.get("ignoreEndPage").setValidators(formValidators);
      this.ignoreBegPage.errorMessages = {
        ...this.ignoreBegPage?.errorMessages,
        max: maxErrorMessage,
      };
      this.ignoreEndPage.errorMessages = {
        ...this.ignoreEndPage?.errorMessages,
        max: maxErrorMessage,
      };
    }

    if (this.invoiceForm) {
      this.invoiceForm.get("invoiceBegPage").setValidators(formValidators);
      this.invoiceForm.get("invoiceEndPage").setValidators(formValidators);
      this.invoiceBegPage.errorMessages = {
        ...this.invoiceBegPage?.errorMessages,
        max: maxErrorMessage,
      };
      this.invoiceEndPage.errorMessages = {
        ...this.invoiceEndPage?.errorMessages,
        max: maxErrorMessage,
      };
    }

    if (this.deleteForm) {
      this.deleteForm.get("deleteBegPage").setValidators(formValidators);
      this.deleteForm.get("deleteEndPage").setValidators(formValidators);
      this.deleteBegPage.errorMessages = {
        ...this.deleteBegPage?.errorMessages,
        max: maxErrorMessage,
      };
      this.deleteEndPage.errorMessages = {
        ...this.deleteEndPage?.errorMessages,
        max: maxErrorMessage,
      };
    }
  }

  assignedPageCount(): void {
    if (this.isRunModeDocument) {
      this.service.getAssigendPagesCount(this.documentId)
        .subscribe((result: number) => {
          this.numberOfAssignedPages = result;
          this.assignedPagesEvent.emit(this.numberOfAssignedPages);
        });
    }
  }

  loadAssignments() {

    this.documentPageAssignment.refresh();

    return;

  }
  pageAssignmentsLoaded(data) {
    this.documentAssignmentSummaries = (data);
    this.unassignedPagesEvent.emit(this.unassignedPages);

    if (this.firstDocumentAssignmentSummaryIsAnInvoice && this.firstDocumentAssignmentSummaryIsValid) {
      this.getPendDropdowns();
    }
    this.initilizeChaseForm();
    this.changeDetector.markForCheck();
  }


  get hasDocumentAssignmentSummaries(): boolean {
    return ArrayHelper.isAvailable(this.documentAssignmentSummaries);
  }

  get firstDocumentAssignmentSummaryIsAnInvoice(): boolean {
    return this.hasDocumentAssignmentSummaries
      && this.documentAssignmentSummaries[0].docType === "Invoice";
  }

  get firstDocumentAssignmentSummaryIsValid(): boolean {
    return this.documentAssignmentSummaries[0].startPage === 1
      && this.documentAssignmentSummaries[0].endPage === this.numberOfPages;
  }

  get unassignedPages(): number[] {
    let unAssignedPages = [];
    const unAssignedDocumentSummaries = this.documentPageAssignment.getUnassignedPages();
    if (ArrayHelper.isAvailable(unAssignedDocumentSummaries)) {
      unAssignedDocumentSummaries.forEach(d => {
        const unAssignedPageRangeForChase = Array(d.endPage - d.startPage + 1).fill(0).map((_, idx) => d.startPage + idx);
        unAssignedPages.push(unAssignedPageRangeForChase);
      });

      unAssignedPages = unAssignedPages.reduce((a, b) => a.concat(b), []);
      unAssignedPages = unAssignedPages.filter((el, i, a) => i === a.indexOf(el));
      unAssignedPages.sort();
    }

    return Array.from(Array(this.numberOfPages), (v, i) => i + 1).filter(i => unAssignedPages.includes(i));
  }


  /**
   * Helper function to extract and parse comma-separated chase IDs from a form control.
   */
  private extractChaseIds(form: FormGroup, controlName: string): number[] {
    if (form && form.controls[controlName]?.value != null) {
      const value = form.controls[controlName].value;
      return value
        .split(",")
        .map(num => Number(num.trim()))
        .filter(num => !isNaN(num));
    }
    return [];
  }

  /**
   * Getter to retrieve chase IDs from chaseForm.
   */
  get targetChaseIds(): number[] {
    return this.extractChaseIds(this.chaseForm, "assignChaseId");
  }

  /**
   * Getter to retrieve chase IDs from invoiceForm.
   */
  get targetInvoiceChaseIds(): number[] {
    return this.extractChaseIds(this.invoiceForm, "invoiceChaseId");
  }

  /**
   * Getter to retrieve chase IDs from pendForm.
   */
  get targetPendChaseIds(): number[] {
    return this.extractChaseIds(this.pendForm, "assignPendChaseId");
  }

  loadPageHistories() {

    this.service
      .getChasePagesHistory(this.documentId, 0)
      .subscribe((data: ChasePageHistory[]) => {
        this.pageHistories = (data);
        this.changeDetector.markForCheck();
      });
  }

  validatePagesViewed(begPage: number, endPage: number): boolean {

    return this.pageViewerComponent.validatePagesViewed(begPage, endPage);
  }

  private isPageRangeValid(begValue: unknown, endValue: unknown): boolean {
    const startPage = Number(begValue);
    const endPage = Number(endValue);

    if (!NumberHelper.isAvailable(startPage) || !NumberHelper.isAvailable(endPage)) {
      this.messagingService.showMessage("Please enter valid start and end page numbers.", SeverityType.ERROR);
      return false;
    }

    if (NumberHelper.isGreaterThan(startPage, endPage)) {
      this.messagingService.showMessage("Start Page cannot be greater than End Page.", SeverityType.ERROR);
      return false;
    }

    return true;
  }

  assignChaseClick(): void {
    if (!this.isPageRangeValid(this.chaseForm.controls.chaseBegPage.value, this.chaseForm.controls.chaseEndPage.value)) {
      return;
    }

    if (this.isChartLakeIntake) {
      this.assignToWorkingPagesForChartLake();
      return;
    }
    if (this.chaseForm.valid) {
      if (!this.validatePagesViewed(this.chaseForm.controls.chaseBegPage.value, this.chaseForm.controls.chaseEndPage.value) && this.reviewAllPagesAttribute) {
        this.messagingService.showMessage("Not all Pages in range have been viewed", SeverityType.ERROR);

        return;
      }
    }

    if (ArrayHelper.isAvailable(this.targetChaseIds)) {
      if (this.targetChaseIds.length > 10) {
        this.messagingService.showToast("You can select a maximum of 10 chases. Please reduce your selection to proceed.", SeverityType.WARN);
        return;
      }

      this.targetChaseIds.forEach(chaseId => {
        if (this.documentId === chaseId) {
          this.messagingService.showMessage("Cannot assign chase pages to the same chase.", SeverityType.ERROR);
          return;
        }
      });

      this.validateMultipleChaseStatusForDocAttachment(this.targetChaseIds);
    }
  }

  checkPageBetween(assignment: MemberAssignmentSummary): any {
        return this.chaseForm.controls.chaseBegPage.value >= assignment.endPage &&
        this.chaseForm.controls.chaseEndPage.value <= assignment.startPage;
  }

  assignToWorkingPagesForChartLake(): void {
    const overlappingDetected = this.documentPageAssignment.chartlakeMedicalRecordPages.some(assignment =>
                      this.checkPageBetween(assignment)) ||
                      this.documentPageAssignment.chartlakeCommittedPageAssignments.some(
                        assignment => this.checkPageBetween(assignment));

    if (overlappingDetected) {
      this.errorMessage = "Selected pages are already assigned to different member." +
                            "If you still want to assign to this member," +
                            "kindly unassign from the earlier member.";
      this.showErrorModal = true;
      return;
    }

    if (this.selectedMember) {
      const assignmentSummary = new MemberAssignmentRequest({
        documentQueueId: this.documentId,
        customerMemberId: this.selectedMember.memberId?.toString(),
        startPage: this.chaseForm.controls.chaseBegPage.value,
        endPage: this.chaseForm.controls.chaseEndPage.value,
        isIgnore: false,
        memberData: new MemberData({
          firstName: this.selectedMember.firstName,
          lastName: this.selectedMember.lastName,
          gender: this.selectedMember.gender,
          dob: this.selectedMember.dob,
          tenantId: this.selectedMember.tenantId,
        }),
      });
      this.service.assignChartLakeWorkingDocumentPageRangesToMember(assignmentSummary).subscribe(
        next => {
          this.messagingService.showToast("Pages assigned successfully", SeverityType.SUCCESS);
          this.loadDocumentSections();
          this.chaseForm.reset();
        }
      );
    } else {
      this.messagingService.showToast("Please select a member", SeverityType.ERROR);
    }
  }

  attachDocToMemberCentricChases(selectedChaseIds: number[]): void {
    if (this.sourceDocumentTypeId === this.runModeDocument) {
      this.memberCentricDocAttachmentService.attachDocToMemberCentricChases(
        selectedChaseIds, Number(this.documentId), DocumentTypeName.DocTypeMedicalRecord, this.docBeginPage, this.docEndPage, PageTypeName.MedicalRecord, true).subscribe(
          next => {
            this.messagingService.showMessage("Chase(s) assigned successfully", SeverityType.SUCCESS);
            this.loadDocumentSections();
            this.assignedPageCount();
            this.chaseForm.reset();
          },
          err => this.messagingService.showMessage("Chase(s) assign Unsuccessful", SeverityType.ERROR));

    } else if (this.sourceDocumentTypeId === this.runModeChase) {
      this.memberCentricDocAttachmentService.copyMrqaChasePagesToMemberCentricChases(this.documentId, selectedChaseIds, DocumentTypeName.DocTypeMedicalRecord,
                                                                                     this.chaseForm.controls.chaseBegPage.value, this.chaseForm.controls.chaseEndPage.value,
                                                                                     PageTypeName.MedicalRecord).subscribe(
          next => {
            this.messagingService.showToast("Chase assigned successfully", SeverityType.SUCCESS);
            this.getData();
            this.assignedPageCount();
            this.loadDocumentSections();
            this.setChangedEvent("movechasepages", { chaseId: this.documentId });
            this.chaseForm.reset();
          },
          err => this.messagingService.showMessage("Chase(s) assign Unsuccessful", SeverityType.ERROR));
    }
  }

  get memberCentricGridData(): MemberCentricChase[] {
    if (ArrayHelper.isAvailable(this.memberCentricData) && this.showMemberCentricDocAttachmentInfo) {
      return this.memberCentricData;
    }

    return null;
  }

  get docBeginPage(): number {
    if (this.showMemberCentricDocAttachmentInfo && StringHelper.isAvailable(this.chaseForm.controls.chaseBegPage.value)) {
      return Number(this.chaseForm.controls.chaseBegPage.value);
    }

    return null;
  }

  get docEndPage(): number {
    if (this.showMemberCentricDocAttachmentInfo && StringHelper.isAvailable(this.chaseForm.controls.chaseEndPage.value)) {
      return Number(this.chaseForm.controls.chaseEndPage.value);
    }

    return null;
  }

  assignPendChaseClick() {
    if (!this.isPageRangeValid(this.pendForm.controls.pendBegPage.value, this.pendForm.controls.pendEndPage.value)) {
      return;
    }

    if (this.pendForm.valid) {
      if (!this.validatePagesViewed(this.pendForm.controls.pendBegPage.value, this.pendForm.controls.pendEndPage.value) && this.reviewAllPagesAttribute) {
        this.messagingService.showMessage("Not all Pages in range have been viewed", SeverityType.ERROR);

        return;
      }

      this.assignPagesToChasePend();
    }
  }

  private assignPagesToChasePend(): void {

    if (this.targetPendChaseIds.length > 10) {
      this.messagingService.showToast("You can select a maximum of 10 chases. Please reduce your selection to proceed.", SeverityType.WARN);
      return;
    }

    const documentPageIds =
      this.pageViewerComponent.getPageKeys(this.pendForm.controls.pendBegPage.value, this.pendForm.controls.pendEndPage.value);
    const documentPageNumbersAsCsv = this.getAllPages(Number(this.pendForm.controls.pendBegPage.value), Number(this.pendForm.controls.pendEndPage.value));
    const owner = this.hasSelectedPendType ? this.selectedPendType.extra.owner : "";
    const pendReasonId = StringHelper.isAvailable(this.pendForm.get(this.pendReasonInput.key).value) ? Number(this.pendForm.get(this.pendReasonInput.key).value) : 0;
    const chasePendItem = new ChasePendItem({
      chasePendId: null,
      pendTypeId: this.selectedPendTypeId,
      pendStatusId: PendStatus.New,
      assignedToUserId: null,
      notes: "",
      chaseIds: ArrayHelper.isAvailable(this.targetPendChaseIds) ? this.targetPendChaseIds : [],
      owner,
      documentPageIds,
      amount: Number(this.pendForm.controls.pendAmount.value),
      invoiceNumber: this.pendForm.controls.pendInvoice.value,
      pendCompanyId: this.pendForm.controls.pendCompany.value,
      documentPageNumbersAsCsv,
      documentQueueId: this.documentId,
      pageRangeStart: this.pendForm.controls.pendBegPage.value,
      pageRangeEnd: this.pendForm.controls.pendEndPage.value,
      pageSource: this.pageSource,
      pendReasonId,
    });
    const documentPageIdRequest = new DocumentPageRequest(
      this.documentId,
      this.pendForm.controls.pendBegPage.value,
      this.pendForm.controls.pendEndPage.value
    );
    if (!documentPageIds || documentPageIds.some(id => id == null)) {
      this.service.getDocumentPageIds(documentPageIdRequest)
      .subscribe(response => {
        if (response.ok) {
          chasePendItem.documentPageIds = response.body.map(item => item.documentPageID);
          this.validateChasePendPages(chasePendItem);
        }
      });
    } else {
      this.validateChasePendPages(chasePendItem);
    }
  }

  /**
   * Validates pend page creation for chases and handles failures.
   * If there are failed validations, it groups the failures by message and shows a modal.
   * If all validations pass, it proceeds to create pend pages for each chase.
   */
  private validateChasePendPages(chasePendItem: any): void {
    // Initially hide the modal
    this.showNotAllowedModal = false;

    // Call service to validate chases for pend page creation
    this.service.validateChasePendPages(
      chasePendItem,
      DocumentTypeName.DocTypeMessage,
      PageTypeName.ProviderMessage
    ).subscribe(data => {

      const failedChases = data.filter(chase => chase.validationStatus === "Fail");

      if (ArrayHelper.isAvailable(failedChases)) {
        const groupMap: { [key: string]: { chaseIds: number[]; message: string } } = {};

        // Group failed chases by the first part of their message (before ';')
        failedChases.forEach(({ chaseId, message }) => {
          const groupKey = message.split(";")[0];

          if (!groupMap[groupKey]) {
            groupMap[groupKey] = { chaseIds: [], message: groupKey };
          }

          groupMap[groupKey].chaseIds.push(chaseId);
        });

        // Convert grouped results to an array for iteration
        const consolidateFailures = Object.values(groupMap);

        this.attachChaseNotAllowedMsg = [];

        // Append each failure group to the error message (each on a new line)
        consolidateFailures.forEach(value => {
          this.attachChaseNotAllowedMsg.push(`${value.chaseIds.length > 1 ? "Chase(s):" : "Chase:"} ${value.chaseIds.join(", ")} ${value.message}.`);
        });

        this.showNotAllowedModal = true;
      } else {
        // If all validations pass, create pend pages for each chase
        this.createChasePendPages(chasePendItem);
      }

      this.changeDetector.markForCheck();
    });
  }

  private createChasePendPages(chasePendItem: any) {
    this.service.createChasePendPages(chasePendItem, DocumentTypeName.DocTypeMessage, PageTypeName.ProviderMessage)
    .subscribe(response => {
      if (response.ok) {
        const successResults = response.body.filter(
          chase => chase.validationStatus === "Success");
        const failedResults = response.body.filter(
          chase => chase.validationStatus === "Failed");

        if (ArrayHelper.isAvailable(successResults)) {
          successResults.map(chase => {
            this.messagingService.showToast(`Pend created successfully`, SeverityType.SUCCESS);
          });

          this.loadDocumentSections();
          this.assignedPageCount();
          this.pendForm.reset();
        }

        if (ArrayHelper.isAvailable(failedResults)) {
          const chaseIds = failedResults.map(chase => chase.chaseId);

          this.attachChaseNotAllowedMsg = [];

          // Compose appropriate message based on the count
          if (chaseIds.length === 1) {
            this.attachChaseNotAllowedMsg.push(`Chase: ${chaseIds[0]} - Pend assignment failed.`);
          } else {
            this.attachChaseNotAllowedMsg.push(`Chase(s): ${chaseIds.join(", ")} - Pend assignment failed.`);
          }

          this.showNotAllowedModal = true;
        }

        this.changeDetector.markForCheck();
      }
    });
  }

  validateChaseStatusForDocAttachment(chaseId: number): void {
    this.showNotAllowedModal = false;

    this.service.validateChaseStatusForDocAttachment(chaseId)
      .subscribe((result: string) => {

        // Only check for not authorized or invalid chase here.  Other validations will occur on WorkingDocument Commit
        // because chase status could have changed before committing
        switch (result) {

          case "invalid":
          case "notAuthorized":
            this.attachChaseNotAllowedMsg.push(`Chase Id: ${chaseId} is invalid`);
            this.showNotAllowedModal = true;
            break;

          default:
            this.assignPageRangeToWorkingDocument(chaseId);
            break;
        }

        this.changeDetector.markForCheck();
      });
  }

  assignPageRangeToWorkingDocument(chaseId): void {
    this.showConfirmationForActiveChases = false;
    this.showConfirmationForInActiveChases = false;

    this.service.assignPageRangeToWorkingDocument(this.sourceDocumentTypeId === this.runModeChase ? "chase2chase" : "chase", String(chaseId),
                                                  this.documentId, DocumentTypeName.DocTypeMedicalRecord, this.chaseForm.controls.chaseBegPage.value,
                                                  this.chaseForm.controls.chaseEndPage.value, PageTypeName.MedicalRecord,
                                                  this.sourceDocumentTypeId === this.runModeChase ? this.documentId : null)
      .subscribe((result: boolean) => {
        if (result) {
          this.messagingService.showToast("Chase assign successful", SeverityType.SUCCESS);
          this.loadDocumentSections();
          this.assignedPageCount();
          this.chaseForm.reset();
        }
      });
  }

  validateMultipleChaseStatusForDocAttachment(chaseIds: number[]): void {
    this.showNotAllowedModal = false;
    this.showConfirmationForActiveChases = false;
    this.showConfirmationForInActiveChases = false;

    const isChase2Chase = this.sourceDocumentTypeId === this.runModeChase;

    const startPage = this.chaseForm.controls.chaseBegPage.value;
    const endPage = this.chaseForm.controls.chaseEndPage.value;

    const documentAssignmentSummaryList: DocumentAssignmentSummary[] = chaseIds.map(chaseId => ({
      documentId: this.documentId,
      chaseId,
      startPage,
      endPage,
      docType: isChase2Chase ? "chase2chase" : "chase",
      pageType: PageTypeName[PageTypeName.MedicalRecord],
      documentTypeId: DocumentTypeName.DocTypeMedicalRecord,
      documentAssignmentTypeId: null,
      pageTypeId: PageTypeName.MedicalRecord,
      document2Id: isChase2Chase ? this.documentId : null,
      document2TypeId: null,
      removeable: null,
      span: null,
      result: null,
      workingDocumentId: null,
      memberId: null,
    }));


    this.service.validateMultipleChaseStatusForDocAttachment(documentAssignmentSummaryList)
      .subscribe(data => {
        // Only check for not authorized or invalid chase here.  Other validations will occur on WorkingDocument Commit
        // because chase status could have changed before committing
        const failedChases = data.filter(
          chase => chase.validationStatus === "invalid" || chase.validationStatus === "notAuthorized" || chase.validationStatus === "Failed");

        if (ArrayHelper.isAvailable(failedChases)) {
            const groupMap: { [key: string]: { chaseIds: number[]; message: string } } = {};

            // Group failed chases by the first part of their message (before ';')
            failedChases.forEach(({ chaseId, message }) => {
              const groupKey = message.split(";")[0];

              if (!groupMap[groupKey]) {
                groupMap[groupKey] = { chaseIds: [], message: groupKey };
              }

              groupMap[groupKey].chaseIds.push(chaseId);
            });

            // Convert grouped results to an array for iteration
            const consolidateFailures = Object.values(groupMap);

            this.attachChaseNotAllowedMsg = [];

            // Append each failure group to the error message (each on a new line)
            consolidateFailures.forEach(value => {
              this.attachChaseNotAllowedMsg.push(`${value.chaseIds.length > 1 ? "Chase(s):" : "Chase:"} ${value.chaseIds.join(", ")} - ${value.message}.`);
            });

            this.showNotAllowedModal = true;
        } else {
          this.assignMultipleChasePageRangeToWorkingDocument(documentAssignmentSummaryList);
        }

        this.changeDetector.markForCheck();
      });
  }

  assignMultipleChasePageRangeToWorkingDocument(documentAssignmentSummaryList: DocumentAssignmentSummary[]): void {

    this.service.assignMultipleChasePageRangeToWorkingDocument(documentAssignmentSummaryList)
      .subscribe(result => {
        const successResults = result.filter(
          chase => chase.validationStatus === "Success");
        const failedResults = result.filter(
          chase => chase.validationStatus === "Failed");

        if (ArrayHelper.isAvailable(successResults)) {
          successResults.map(chase => {
            this.messagingService.showToast(`Chase assign successful`, SeverityType.SUCCESS);
          });
          this.loadDocumentSections();
          this.assignedPageCount();
          this.chaseForm.reset();
        }

        if (ArrayHelper.isAvailable(failedResults)) {
          const chaseIds = failedResults.map(chase => chase.chaseId);

          this.attachChaseNotAllowedMsg = [];

          // Compose appropriate message based on the count
          if (chaseIds.length === 1) {
            this.attachChaseNotAllowedMsg.push(`Chase: ${chaseIds[0]} assignment failed.`);
          } else {
            this.attachChaseNotAllowedMsg.push(`Chase(s): ${chaseIds.join(", ")} assignment failed.`);
          }

          this.showNotAllowedModal = true;
        }

        this.changeDetector.markForCheck();
      });
  }


  /**
 * Triggered when the user clicks the "Assign Invoice" button.
 */
  assignInvoiceClick(): void {
    // Hide any existing error modals
    this.showNotAllowedModal = false;

    if (!this.isPageRangeValid(this.invoiceForm.controls.invoiceBegPage.value, this.invoiceForm.controls.invoiceEndPage.value)) {
      return;
    }

    if (this.invoiceForm.valid) {
      // Validate that all pages in the specified range have been viewed, if required
      const beginPage = this.invoiceForm.controls.invoiceBegPage.value;
      const endPage = this.invoiceForm.controls.invoiceEndPage.value;

      if (
        !this.validatePagesViewed(beginPage, endPage) &&
        this.reviewAllPagesAttribute
      ) {
        // Show error if page view requirement is not met
        this.messagingService.showToast("Not all Pages in range have been viewed", SeverityType.ERROR);
        return;
      }
    }

    if (ArrayHelper.isAvailable(this.targetInvoiceChaseIds)) {

      if (this.targetInvoiceChaseIds.length > 10) {
        this.messagingService.showToast("You can select a maximum of 10 chases. Please reduce your selection to proceed.", SeverityType.WARN);
        return;
      }

      // Call the service to validate the selected chase IDs
      this.invoicesService.validateChases(this.targetInvoiceChaseIds).subscribe(data => {
        const failedResults = data.filter(chase => chase.validationStatus === "Fail");

        if (ArrayHelper.isAvailable(failedResults)) {

          const groupMap: { [key: string]: { chaseIds: number[]; message: string } } = {};

          // Group failed chases by the first part of their message (before ';')
          failedResults.forEach(({ chaseId, message }) => {
          const groupKey = message.split(";")[0];

          if (!groupMap[groupKey]) {
            groupMap[groupKey] = { chaseIds: [], message: groupKey };
          }

          groupMap[groupKey].chaseIds.push(chaseId);
        });

        // Convert grouped results to an array for iteration
          const consolidateFailures = Object.values(groupMap);

          this.attachChaseNotAllowedMsg = [];

        // Append each failure group to the error message (each on a new line)
          consolidateFailures.forEach(value => {
          this.attachChaseNotAllowedMsg.push(`${value.chaseIds.length > 1 ? "Chase(s):" : "Chase:"} ${value.chaseIds.join(", ")} ${value.message}.`);
        });

          this.showNotAllowedModal = true;

        } else if (data.filter(chase => chase.validationStatus === "Success").length > 0) {
          // If all validations succeed, proceed to assign invoice
          this.assignInvoiceToChase();
        }

        this.changeDetector.markForCheck();
      });
    }
  }

  assignInvoiceToChase(): void {
    let documentPageIds =
      this.pageViewerComponent.getPageKeys(this.invoiceForm.controls.invoiceBegPage.value, this.invoiceForm.controls.invoiceEndPage.value);
    if (this.pageSource === PageSource.DOC_QA) {
      const request = {
        chaseId: this.documentId,
        begPage: this.invoiceForm.controls.invoiceBegPage.value,
        endPage: this.invoiceForm.controls.invoiceEndPage.value,
      };
      this.service.getChasePageDetails(request).subscribe(response => {
        if (response.ok) {
          documentPageIds = response.body.map(item => item.documentPageID);
          this.assignPagesToInvoice(documentPageIds);
        }
      });
      return;
    }
    const documentPageIdRequest = new DocumentPageRequest(
      this.documentId,
      this.invoiceForm.controls.invoiceBegPage.value,
      this.invoiceForm.controls.invoiceEndPage.value
    );
    this.service.getDocumentPageIds(documentPageIdRequest)
      .subscribe(response => {
        if (response.ok) {
          documentPageIds = response.body.map(item => item.documentPageID);
          this.assignPagesToInvoice(documentPageIds);
        }
      });

    // TODO: fix hardcode doctye to get from select box

  }

  assignPagesToInvoice(documentPageIds: number[]): void {
    this.service.assignPagesToMultipleEntity(
      "invoice",
      this.targetInvoiceChaseIds,
      this.documentId,
      DocumentTypeName.DocTypeInvoice,
      documentPageIds,
      PageTypeName.Invoice)
      .subscribe(result => {

        const successResults = result.filter(
          chase => chase.validationStatus === "Success");
        const failedResults = result.filter(
          chase => chase.validationStatus === "Failed");

        if (ArrayHelper.isAvailable(successResults)) {
          successResults.map(chase => {
            this.messagingService.showToast(`Invoice assign successful`, SeverityType.SUCCESS);
          });

          this.loadAssignments();
          this.assignedPageCount();
          this.invoiceForm.reset();
        }

        if (ArrayHelper.isAvailable(failedResults)) {
          const chaseIds = failedResults.map(chase => chase.chaseId);

          this.attachChaseNotAllowedMsg = [];

          // Compose appropriate message based on the count
          if (chaseIds.length === 1) {
            this.attachChaseNotAllowedMsg.push(`Chase: ${chaseIds[0]} - Invoice assignment failed.`);
          } else {
            this.attachChaseNotAllowedMsg.push(`Chase(s): ${chaseIds.join(", ")} - Invoice assignment failed.`);
          }

          this.showNotAllowedModal = true;
        }

        this.changeDetector.markForCheck();
      });
  }

  assignIgnoreClick() {
    if (this.ignoreForm.valid) {
      if (!this.validatePagesViewed(
        this.ignoreForm.get(this.ignoreBegPage.getMasterKey()).value,
        this.ignoreForm.get(this.ignoreEndPage.getMasterKey()).value) && this.reviewAllPagesAttribute) {
        this.messagingService.showToast("Not all Pages in range have been viewed", SeverityType.ERROR);
        return;
      }
    }
    if (this.isChartLakeIntake) {
      this.assignIgnoreToChartLakeWorkingDocument();
    } else {
      this.assignIgnoreToWorkingDocument();
    }
  }

  assignIgnoreToChartLakeWorkingDocument(): void {
    const request = new MemberAssignmentRequest({
      documentQueueId: this.documentId,
      startPage: this.ignoreForm.get(this.ignoreBegPage.getMasterKey()).value,
      endPage: this.ignoreForm.get(this.ignoreEndPage.getMasterKey()).value,
      isIgnore: true,
    });
    this.service.ignoreChartLakeWorkingDocumentPageAssignments(request)
      .subscribe((result: any) => {
        if (result) {
          this.messagingService.showToast("Pages ignored successfully", SeverityType.SUCCESS);
          this.loadDocumentSections();
          this.ignoreForm.reset();
        }
      });
  }

  assignIgnoreToWorkingDocument() {

    this.service.assignPageRangeToWorkingDocument("document", "0",
                                                  this.documentId, DocumentTypeName.DocTypeMedicalRecord, this.ignoreForm.get(this.ignoreBegPage.getMasterKey()).value,
                                                  this.ignoreForm.get(this.ignoreEndPage.getMasterKey()).value, PageTypeName.Ignore, null)
      .subscribe((result: boolean) => {
        if (result) {
          this.messagingService.showMessage("Ignore assign successful", SeverityType.SUCCESS);
          this.loadDocumentSections();
          this.assignedPageCount();
          this.loadDocumentSections();
          this.ignoreForm.reset();
        }
      });
  }

  confirmEntityUnassignment(data: DocumentAssignmentSummary): void {
    this.unAssignEntityAlertVisible = true;
    this.docAssignmentData = data;
  }

  deleteEntityAssignedPages(): void {
    this.service.deletePagesToEntity("chase"
      ,                              String(this.docAssignmentData.chaseId)
      ,                              this.docAssignmentData.documentId
      ,                              this.docAssignmentData.documentTypeId
      ,                              this.docAssignmentData.startPage
      ,                              this.docAssignmentData.endPage
      ,                              this.sourceDocumentTypeId)
      .subscribe((result: boolean) => {
        if (result) {
          this.messagingService.showToast("Chase Page Deletion Successful", SeverityType.SUCCESS);
          this.loadDocumentSections();
        }
      });
  }

  async deleteFromChaseClick() {
    this.disableDeleteBtn = true;
    this.loaderService.isLoading.next(true);
    await (await this.pageViewerComponent.getAllDocumentPages(this.deleteForm.controls.deleteBegPage.value, this.deleteForm.controls.deleteEndPage.value)).toPromise().then(documentPages => {
      const documentPageIds = documentPages.pages
        .filter(page => page && page.pageNumber >= this.deleteForm.controls.deleteBegPage.value && page.pageNumber <= this.deleteForm.controls.deleteEndPage.value)
        .map(prop => prop.documentPageId);
      this.deleteCharts(documentPageIds);
    });
  }

  deleteCharts(documentPageIds) {
    this.disableDeleteBtn = false;
    this.loaderService.isLoading.next(false);
    this.service.deleteChasePages(this.documentId, DocumentTypeName.DocTypeMedicalRecord, documentPageIds, PageTypeName.MedicalRecord)
      .subscribe((result: boolean) => {
        if (result) {
          this.messagingService.showToast("Delete successful", SeverityType.SUCCESS);
          this.initializeDoc();
          this.pageViewerComponent.removePages(this.deleteForm.controls.deleteBegPage.value, this.deleteForm.controls.deleteEndPage.value);
          this.assignedPageCount();
          this.loadDocumentSections();
          this.setChangedEvent("deletedchasepages", { chaseId: this.documentId });
          this.deleteForm.reset();
        }
      });
  }


  memberValidationSubmit(memberValidation: MemberValidation): void {
    this.memberValidationService.submit(memberValidation, this.status).subscribe(data => {
      this.memberValidationData = data;
      this.savedIsValidMember = this.memberValidationData.isValid;

      // Cant do MRQA if not valid member so let parent component know
      if (this.memberValidationData.isValid !== true) {
        this.setChangedEvent("membernotvalid", { chaseId: this.documentId });
      }
      this.messagingService.showToast("Member Validation Completed", SeverityType.SUCCESS);
      this.changeDetector.markForCheck();
    });
  }

  loadDocumentSections() {

    this.loadAssignments();
    this.loadPageHistories();
  }

  toggleAssignSection(section: string) {
    this.lastSelectedSection = section;
    switch (section) {
      case "pend":
        this.initilizePendIntake();
        break;
      case "ignore":
        this.initilizeIgnoreForm();
        break;
      case "chase":
        this.initilizeChaseForm();
        break;
      case "invoice":
        this.initilizeInvoiceForm();
        break;
      case "delete":
        this.initilizeDeleteForm();
        break;
      default:
        break;
    }

    this.currentAssignSection = this.currentAssignSection === section ? "" : section;
  }

  private initilizeIgnoreForm(): void {
    const formValidators = [...this.defaultFormValidators];
    formValidators.push(Validators.max(this.maximumPages));

    this.ignoreBegPage = new Textbox({
      key: "ignoreBegPage",
      type: TextboxType.NUMBER,
      label: "Start Pg",
      validators: formValidators,
      errorMessages: {
        required: `Enter number between 1 - ${this.maximumPages}`,
        min: `Enter number between 1 - ${this.maximumPages}`,
        max: `Enter number between 1 - ${this.maximumPages}`,
        pattern: `Enter number between 1 - ${this.maximumPages}`,
      },
      placeholder: "0",
    });

    this.ignoreEndPage = new Textbox({
      key: "ignoreEndPage",
      type: TextboxType.NUMBER,
      label: "End Pg",
      validators: formValidators,
      errorMessages: {
        required: `Enter number between 1 - ${this.maximumPages}`,
        min: `Enter number between 1 - ${this.maximumPages}`,
        max: `Enter number between 1 - ${this.maximumPages}`,
        pattern: `Enter number between 1 - ${this.maximumPages}`,
      },
      placeholder: "0",
    });

    this.ignoreForm = this.formService.createFormGroup([
      this.ignoreBegPage,
      this.ignoreEndPage,
    ]);
  }

  private initilizeChaseForm(): void {
    const formValidators = [...this.defaultFormValidators];
    formValidators.push(Validators.max(this.maximumPages));

    this.chaseBegPage = new Textbox({
      key: "chaseBegPage",
      type: TextboxType.NUMBER,
      label: "Start Pg",
      validators: formValidators,
      errorMessages: {
        required: `Enter number between 1 - ${this.maximumPages}`,
        min: `Enter number between 1 - ${this.maximumPages}`,
        max: `Enter number between 1 - ${this.maximumPages}`,
        pattern: `Enter number between 1 - ${this.maximumPages}`,
      },
      placeholder: "0",
    });

    this.chaseEndPage = new Textbox({
      key: "chaseEndPage",
      type: TextboxType.NUMBER,
      label: "End Pg",
      validators: formValidators,
      errorMessages: {
        required: `Enter number between 1 - ${this.maximumPages}`,
        min: `Enter number between 1 - ${this.maximumPages}`,
        max: `Enter number between 1 - ${this.maximumPages}`,
        pattern: `Enter number between 1 - ${this.maximumPages}`,
      },
      placeholder: "0",
    });

    this.assignChaseId = new Textbox({
      key: "assignChaseId",
      type: TextboxType.TEXT,
      readonly: this.isChartLakeIntake, // Disable input if it's ChartLakeIntake as Member ID will be auto-populated by search
      disabled: this.isChartLakeIntake,
      label: this.isChartLakeIntake ? "Member ID" : "Chase ID",
      validators: [
        Validators.required,
      ],
      errorMessages: {
        required: this.isChartLakeIntake ? "Member Id is required" : "Chase Id is required",
        pattern: "Chase Id should be valid",
      },
    });

    if (!this.isChartLakeIntake) {
      this.assignChaseId.validators.push(Validators.pattern(RegExHelper.chaseIdsWithCommaPattern));
    }

    this.chaseForm = this.formService.createFormGroup([
      this.chaseBegPage,
      this.chaseEndPage,
      this.assignChaseId,
    ]);
  }

  private initilizeInvoiceForm(): void {
    const formValidators = [...this.defaultFormValidators];
    formValidators.push(Validators.max(this.maximumPages));

    this.invoiceBegPage = new Textbox({
      key: "invoiceBegPage",
      type: TextboxType.NUMBER,
      label: "Start Pg",
      validators: formValidators,
      errorMessages: {
        required: `Enter number between 1 - ${this.maximumPages}`,
        min: `Enter number between 1 - ${this.maximumPages}`,
        max: `Enter number between 1 - ${this.maximumPages}`,
        pattern: `Enter number between 1 - ${this.maximumPages}`,
      },
      placeholder: "0",
    });

    this.invoiceEndPage = new Textbox({
      key: "invoiceEndPage",
      type: TextboxType.NUMBER,
      label: "End Pg",
      validators: formValidators,
      errorMessages: {
        required: `Enter number between 1 - ${this.maximumPages}`,
        min: `Enter number between 1 - ${this.maximumPages}`,
        max: `Enter number between 1 - ${this.maximumPages}`,
        pattern: `Enter number between 1 - ${this.maximumPages}`,
      },
      placeholder: "0",
    });

    this.invoiceChaseId = new Textbox({
      key: "invoiceChaseId",
      type: TextboxType.TEXT,
      label: "Chase ID",
      validators: [
        Validators.required,
        Validators.pattern(RegExHelper.chaseIdsWithCommaPattern),
      ],
      errorMessages: {
        required: "Chase Id is required",
        pattern: "Chase Id should be valid",
      },
    });

    this.invoiceForm = this.formService.createFormGroup([
      this.invoiceBegPage,
      this.invoiceEndPage,
      this.invoiceChaseId,
    ]);
  }

  private initilizeDeleteForm(): void {
    const formValidators = [...this.defaultFormValidators];

    this.deleteBegPage = new Textbox({
      key: "deleteBegPage",
      type: TextboxType.NUMBER,
      label: "Start Pg",
      validators: formValidators,
      errorMessages: {
        required: `Enter number between 1 - ${this.maximumPages}`,
        min: `Enter number between 1 - ${this.maximumPages}`,
        max: `Enter number between 1 - ${this.maximumPages}`,
        pattern: `Enter number between 1 - ${this.maximumPages}`,
      },
      placeholder: "0",
    });

    this.deleteEndPage = new Textbox({
      key: "deleteEndPage",
      type: TextboxType.NUMBER,
      label: "End Pg",
      validators: formValidators,
      errorMessages: {
        required: `Enter number between 1 - ${this.maximumPages}`,
        min: `Enter number between 1 - ${this.maximumPages}`,
        max: `Enter number between 1 - ${this.maximumPages}`,
        pattern: `Enter number between 1 - ${this.maximumPages}`,
      },
      placeholder: "0",
    });

    this.deleteForm = this.formService.createFormGroup([
      this.deleteBegPage,
      this.deleteEndPage,
    ]);
  }

  navToChase(item: DocumentAssignmentSummary) {

    this.router.navigate(["members", "chase", item.chaseId]);
  }

  trackByIndex(index, item) {
    return index;
  }

  setChangedEvent(eventName, content) {
    const event = new EmitState(eventName, content);
    this.changedEvent.emit(event);
  }

  restoreChasePage(documentPageId) {

    const documentPageIds: number[] = [documentPageId];

    this.service.assignPagesToEntity("chase", String(this.documentId),
                                     this.documentId, DocumentTypeName.DocTypeMedicalRecord, documentPageIds, PageTypeName.MedicalRecord)
      .subscribe((result: boolean) => {

        if (result) {
          this.messagingService.showToast("Page restore successful", SeverityType.SUCCESS);

          DocumentPageViewerComponent.documentId.next(this.documentId);
          this.loadDocumentSections();
          this.setChangedEvent("restorechasepages", { chaseId: this.documentId });
        }
      });
  }

  validateForChaseSubmit() {

    if (this.allowEdit === false) {
      this.messagingService.showMessage("You are not allowed to make changes to this Chase", SeverityType.ERROR);
      return false;
    }

    if (this.reviewAllPagesAttribute) {
      if (!this.pageViewerComponent.validateAllPagesViewed()) {
        this.messagingService.showMessage("All Chase Pages must be viewed to SUBMIT", SeverityType.ERROR);
        return false;
      }
    }

    if (!this.savedIsValidMember) {
      this.messagingService.showMessage("Member Validtion must be completed to SUBMIT", SeverityType.ERROR);
      return false;
    }

    if (!this.encounterValidationFlag) {
      this.messagingService.showMessage("All Dates Of Service Validation must be completed to SUBMIT", SeverityType.ERROR);
      return false;
    }

    return true;
  }


  validateForDocumentSubmit() {

    if (this.reviewAllPagesAttribute) {
      if (!this.pageViewerComponent.validateAllPagesViewed()) {
        this.messagingService.showMessage("All Document Pages must be viewed", SeverityType.ERROR);
        return false;
      }
    }

    if (!((this.documentAssignmentSummaries && this.documentAssignmentSummaries.length > 0) ||
          (this.isChartLakeIntake && this.documentPageAssignment.chartLakeCommittedPageAssignments.data.length > 0))) {

      let msg = `At least one Page must be assigned to a ${this.isChartLakeIntake ? "Member" : "Chase"} to SUBMIT.`;
      msg += "  If you want to submit without any pages assigned, use the 'REMOVE' button.  This will remove the Document from the active Intake Queue";
      this.messagingService.showMessage(msg, SeverityType.ERROR);
      return false;

    }

    return true;
  }

  pageViewerMaximizeChange(event) {

  }

  private getPendDropdowns(): void {

    this.pendService
      .getPendDropdown(false)
      .pipe(map((result: any) => {
        return result.pendCodes.map(item => new SelectableInput({
          text: item.displayName,
          value: item.pendTypeId,
          extra: { owner: item.defaultOwner, isThirdParty: item.isThirdParty },
        }));
      }))
      .subscribe(options => {
        this.pendTypes = new Dropdown({ ...this.pendTypes, options } as any);
        this.changeDetector.markForCheck();
      });
  }

  get thirdPartyPends(): SelectableInput[] {
    return this.pendTypes.options.filter(a => a.extra.isThirdParty);
  }

  private getPendCompaniesDropdown(): void {
    this.pendService.getPendCompaniesDropdown()
      .pipe(map((result: any): void => {
        return result.map(item => new SelectableInput({
          text: item.value,
          value: item.key,
        }));
      }))
      .subscribe(data => {
        this.pendCompany = new Dropdown({ ...this.pendCompany, options: data } as any);
        this.changeDetector.markForCheck();
      });

  }

  get thirdPartyPendCodesCsv(): string {
    return this.thirdPartyPends
      .map(a => a.text.split("-")[0])
      .join(", ");
  }

  private initilizePendIntake() {
    const formValidators = [...this.defaultFormValidators];
    formValidators.push(Validators.max(this.maximumPages));

    this.pendBegPage = new Textbox({
      key: "pendBegPage",
      type: TextboxType.NUMBER,
      label: "Start Pg",
      validators: formValidators,
      errorMessages: {
        required: `Enter number between 1 - ${this.maximumPages}`,
        min: `Enter number between 1 - ${this.maximumPages}`,
        max: `Enter number between 1 - ${this.maximumPages}`,
        pattern: `Enter number between 1 - ${this.maximumPages}`,
      },
      placeholder: "0",
    });

    this.pendEndPage = new Textbox({
      key: "pendEndPage",
      type: TextboxType.NUMBER,
      label: "End Pg",
      validators: formValidators,
      errorMessages: {
        required: `Enter number between 1 - ${this.maximumPages}`,
        min: `Enter number between 1 - ${this.maximumPages}`,
        max: `Enter number between 1 - ${this.maximumPages}`,
        pattern: `Enter number between 1 - ${this.maximumPages}`,
      },
      placeholder: "0",
    });

    this.pendAmount = new Textbox({
      key: "pendAmount",
      label: "Amount",
      validators: [
        Validators.required,
        Validators.min(0),
        Validators.max(10000),
        Validators.pattern(RegExHelper.number),
      ],
      errorMessages: {
        required: "Enter number between 0 - 10,000",
        min: "Enter number between 0 - 10,000",
        max: "Enter number between 0 - 10,000",
        pattern: "Enter valid number not more than 2 digits after decimal.",
      },
      placeholder: "0.00",
    });

    this.pendInvoice = new Textbox({
      key: "pendInvoice",
      label: "Invoice Number",
      validators: [Validators.maxLength(10)],
      errorMessages: {
        maxlength: "Invoice number can not be more than 10 characters.",
      },
    });

    this.assignPendChaseId = new Textbox({
      key: "assignPendChaseId",
      type: TextboxType.TEXT,
      label: "Chase ID",
      validators: [
        Validators.required,
        Validators.pattern(RegExHelper.chaseIdsWithCommaPattern),
      ],
      errorMessages: {
        required: "Chase Id is required",
        pattern: "Chase Id should be valid",
      },
    });

    this.pendTypes = new Dropdown({
      key: "pendCode",
      label: "Pend Code",
      placeholder: "Select...",
      validators: [Validators.required],
      errorMessages: {
        required: "Pend Code is required.",
      },
      appendTo: "body",
    });

    this.pendCompany = new Dropdown({
      key: "pendCompany",
      label: "Company",
      placeholder: "Select...",
      validators: [Validators.required],
      errorMessages: {
        required: "Company is required.",
      },
    });

    this.pendReasonInput = new Dropdown({
      key: "pendReasonId",
      label: "Reason",
      placeholder: "Select from List",
      disabled: true,
      hidden: true,
      appendTo: "body",
    });

    this.setForm();
    this.getPendDropdowns();
  }

  setForm() {
    this.pendForm = this.formService.createFormGroup([
      this.pendBegPage,
      this.pendEndPage,
      this.pendAmount,
      this.pendInvoice,
      this.assignPendChaseId,
      this.pendTypes,
      this.pendCompany,
      this.pendReasonInput]);
  }

  changePendType() {
    if (this.hasSelectedPendType) {
      if (this.isThirdPartyPendTypeSelected) {
        this.getPendCompaniesDropdown();
        this.pendForm.controls.pendCompany.enable();
        this.pendForm.controls.pendAmount.enable();
        this.pendForm.controls.pendInvoice.enable();
      } else {
        this.getPendReasons();
        this.pendForm.controls.pendCompany.disable();
        this.pendForm.controls.pendAmount.disable();
        this.pendForm.controls.pendInvoice.disable();
        this.pendForm.patchValue({
          pendAmount: null,
          pendInvoice: null,
          pendCompany: null,
        });
      }

      this.changeDetector.markForCheck();
    }
  }

  get selectedPendTypeId(): number {
    const selectedPendTypeId = Number(this.pendForm.get(this.pendTypes.key).value);
    return selectedPendTypeId;
  }

  get hasSelectedPendType(): boolean {
    return this.selectedPendType != null;
  }

  get selectedPendType(): SelectableInput {
    const selectedPendType = this.pendTypes.options.find(a => Number(a.value) === this.selectedPendTypeId);
    return selectedPendType;
  }

  get isThirdPartyPendTypeSelected(): boolean {
    return this.hasSelectedPendType && this.selectedPendType.extra.isThirdParty;
  }

  get maximumPages(): number {
    return this.pageViewerComponent?.totalPages || this.numberOfPages || 1;
  }

  getAllPages(start: number, end: number): string {
    return Array.from({ length: (end - start) + 1 }, (_, i) => start + (i * 1)).join(",");
  }

  get isOcrDataAvailable(): boolean {
    return this.documentSummary ? this.documentSummary.ocrDataAvailable : false;
  }

  get isRunModeDocument(): boolean {
    return this.runMode === this.runModeDocument;
  }

  get isRunModeChase(): boolean {
    return this.runMode === this.runModeChase;
  }

  get pageSource(): string {
    return this.isRunModeChase ? "DOCQA" : "DOCINTAKE";
  }

  onPageAssignmentGotoPage($event) {


    this.pageViewerComponent.gotoPage($event);
  }

  private getPendReasons(): void {
    const pendCodeValue = this.pendForm.get(this.pendTypes.key).value;

    if (pendCodeValue === PendType.PC100 || pendCodeValue === PendType.PC107) {
      this.pendForm.get(this.pendReasonInput.key).enable();
      this.pendReasonInput = new Dropdown({ ...this.pendReasonInput, hidden: false } as any);
      this.pendService.getPendReasons(pendCodeValue).subscribe(data => {
        this.pendReasonInput = new Dropdown({ ...this.pendReasonInput, options: data } as any);
        this.pendForm.get(this.pendReasonInput.key).reset();
        this.changeDetector.markForCheck();
      });
    } else {
      this.pendForm.get(this.pendReasonInput.key).disable();
      this.pendReasonInput = new Dropdown({ ...this.pendReasonInput, hidden: true } as any);


    }
  }

  get isReasonPendType(): boolean {
    const pendCodeValue = this.pendForm.get(this.pendTypes.key).value;
    return (pendCodeValue === PendType.PC100 || pendCodeValue === PendType.PC107);
  }

  get documentFileName(): string {
    if (this.runMode === this.runModeDocument && this.documentSummary) {

      return this.documentSummary.fileName;
    } else {

      return null;
    }
  }

  get showIncorrectMemberValidationInputs(): string {
    return !this.showMemberInputs ? "membervalidation__incorrectMemberValidation" : "";
  }

  showMemberValidationInputs(isCorrectMember: boolean): void {
    this.showMemberInputs = isCorrectMember;
  }
  get documentAddressId(): number {
    if (this.runMode === this.runModeDocument && this.documentSummary) {

      return this.documentSummary.masterDocumentSourceId;
    } else {

      return null;
    }
  }

  datesOfServiceValidation(event: Encounter[]): void {
    this.encounterValidation = event;
    this.encounterValidationFlag = true;

    this.encounterValidation.forEach(e => {
      if (e.enc == null || e.enc == undefined) {
        this.encounterValidationFlag = false;
      } else if ((e.enc === true) && (e.sig == null || e.sig == undefined)) {
        this.encounterValidationFlag = false;
      }
    });

    this.checkIfDosPursuitNeedToBeCreated();
  }

  checkIfDosPursuitNeedToBeCreated(): void {
    if (this.showMemberInputs && !this.isPursuitChase) {
      if (this.encounterValidation.some(e => e.enc === false || e.sig === false)) {
        this.createDosPursuit.emit("new");
      } else {
        this.createDosPursuit.emit(null);
      }
    } else if (this.showMemberInputs && this.isPursuitChase) {
      if ((this.encounterValidation.some(e => e.enc === true || e.sig === true))
        || !(this.encounterValidation.some(e => e.enc === true || e.sig === true))) {
        this.createDosPursuit.emit("closed");
      } else {
        this.createDosPursuit.emit(null);
      }
    }
  }
}

